import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=df2fca3a&scoped=true&"
var script = {}
import style0 from "./Welcome.vue?vue&type=style&index=0&id=df2fca3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2fca3a",
  null
  
)

export default component.exports